import React from 'react';
import styled from 'styled-components';

// 스타일링된 컴포넌트를 생성합니다.
const TutorialArea = styled.div`
  #clip-01 {
    --x: 22px;
    --y: 164px;
    --width: 113px;
    --height: 40px;

    top: 0;
    left: 0;
    width: 1920px;
    height: 1080px;
  }

  #text-01 {
    top: 167px;
    left: 165px;
  }
`;

const IssueTrend03 = () => {
  return (
    <>
      <TutorialArea className='tutorial-area'>
        <div id="clip-01" className="clip-box">
          <div id="clip-01-hole" className="hole" />
          <div id="clip-01-border" className="border" />
        </div>

        <div className="text-box">
          <div id="text-01" className="text">You can choose a view mode with or without sections</div>
        </div>
      </TutorialArea>
    </>
  );
};

export default IssueTrend03;